import React, { Component } from "react";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import { t } from './i18n';

/**
 * deposit2.js — Dynamic Deposit Page
 * Route: /deposit2  →  tabselect: 28
 *
 * Calls /api/v1/getdepositconfig to determine which methods are enabled,
 * then shows/hides tabs accordingly. Does NOT modify the existing deposit
 * UI in main.js.
 *
 * Methods:
 *   1. ธนาคารธรรมดา    (hasBank = true)
 *   2. อัพโหลด Slip   (hasBankAutoslip = true, autoslip=1)
 *   3. ทรูมันนี่        (hasTruewallet = true)
 *   4. ของขวัญทรูมันนี่ (hasTruegift = true — same wallet, different method)
 *   5. Payment Gateway (hasPaymentGateway = true)
 */
class Deposit2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            config: null,
            mainacc: null,
            mainaccAutoslip: null,
            truewallet: null,
            paymentgateway: null,
            cryptowallets: [],
            activeTab: null,        // set after config loads
            activeCryptoIdx: 0,     // selected wallet index in crypto tab
            copySuccess: false,
            cryptoCopied: null,     // "address" | "usdt" | null
            cryptoThbAmount: "",    // THB input for converter
            // Slip upload (autoslip)
            slipFile: null,
            slipUploading: false,
            slipSuccess: false,
            // TrueMoney
            truemoneyAmount: "",
            truemoneyPhone: "",
            truemoneySubmitting: false,
            // TrueMoney Gift
            giftUrl: "",
            giftSubmitting: false,
            // Deposit amount input
            depositAmount: "",
            // User's own bank
            userbank: null,
            // Bank QR/payment result
            bankQR: null,
            bankLoading: false,
            bankLink: null,
            // Payment Gateway
            paymentAmount: "",
            paymentLoading: false,
            paymentQR: null,
            paymentLink: null,
            paymentStep: "input",   // "input" | "result"
            // ===== KBANK: จองยอดทศนิยมก่อนโอน (บัญชีรับฝากกสิกร) =====
            expStep: "input",       // "input" | "reserved"
            expInput: "",
            expLoading: false,
            expId: null,
            expDecimal: null,       // ยอดทศนิยมที่ต้องโอนเป๊ะ
            expBaht: null,          // ยอดที่จะได้รับเครดิต
            expSecLeft: 0,
            expMatched: false,
            expExpiredNote: false,
        };
        this._expTimer = null;
        this._expPoll = null;
    }

    // ===== KBANK: จองยอดทศนิยมก่อนโอน =====
    isKbankAcc = (acc) => {
        const n = ((acc && acc.fullname_th) || "").toLowerCase();
        return n.includes("กสิกร") || n.includes("kbank");
    };

    stopExpTimers = () => {
        if (this._expTimer) { clearInterval(this._expTimer); this._expTimer = null; }
        if (this._expPoll) { clearInterval(this._expPoll); this._expPoll = null; }
    };

    startExpTimers = (sec) => {
        this.stopExpTimers();
        this.setState({ expSecLeft: sec });
        this._expTimer = setInterval(() => {
            this.setState((prev) => {
                if (prev.expSecLeft <= 1) { this.stopExpTimers(); return { expSecLeft: 0, expStep: "input", expExpiredNote: true }; }
                return { expSecLeft: prev.expSecLeft - 1 };
            });
        }, 1000);
        this._expPoll = setInterval(this.pollExpect, 4000);
    };

    pollExpect = async () => {
        const { expId } = this.state;
        if (!expId) return;
        const token = localStorage.getItem("auth_token");
        try {
            const res = await instance.post("/api/v1/checkdepositexpect",
                { System: Systems, id: expId },
                { headers: { Authorization: `Bearer ${token}` } });
            if (res.data && res.data.matched) {
                this.stopExpTimers();
                this.setState({ expMatched: true });
            } else if (res.data && res.data.found && Number(res.data.matchStatus) === 4) {
                this.stopExpTimers();
                this.setState({ expStep: "input", expId: null, expExpiredNote: true });
            }
        } catch (e) { /* ignore */ }
    };

    createExpect = async () => {
        const amt = Math.round(Number(this.state.expInput) || 0);
        if (!amt || amt <= 0) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        const bankid = (this.state.mainacc && this.state.mainacc.bankid) || null;
        this.setState({ expLoading: true, expExpiredNote: false });
        try {
            const res = await instance.post("/api/v1/createdepositexpect",
                { System: Systems, username: Username, amount: amt, decimal: 1, bankid },
                { headers: { Authorization: `Bearer ${token}` } });
            const d = res.data || {};
            if (d.status === 200 && d.id) {
                const dec = (d.amount_decimal != null) ? d.amount_decimal : (Number(d.amount_kip) / 100);
                const sec = (d.secondsLeft != null) ? d.secondsLeft : ((d.expireMin || 30) * 60);
                this.setState({
                    expStep: "reserved", expId: d.id,
                    expDecimal: Number(dec), expBaht: Number(d.amount_baht) || amt,
                    expMatched: false,
                });
                this.startExpTimers(sec);
            }
        } catch (e) { console.error("[deposit2] createExpect error:", e); }
        this.setState({ expLoading: false });
    };

    cancelExpect = async () => {
        const { expId } = this.state;
        const token = localStorage.getItem("auth_token");
        this.stopExpTimers();
        this.setState({ expStep: "input", expId: null, expDecimal: null, expMatched: false, expSecLeft: 0 });
        if (expId) {
            try {
                await instance.post("/api/v1/canceldepositexpect",
                    { System: Systems, id: expId },
                    { headers: { Authorization: `Bearer ${token}` } });
            } catch (e) { /* ignore */ }
        }
    };

    resetExpect = () => {
        this.stopExpTimers();
        this.setState({ expStep: "input", expId: null, expDecimal: null, expBaht: null, expSecLeft: 0, expMatched: false, expInput: "" });
    };

    maybeResumeExpect = async () => {
        if (!this.isKbankAcc(this.state.mainacc)) return;
        const token = localStorage.getItem("auth_token");
        if (!token) return;
        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;
            const res = await instance.post("/api/v1/getdepositexpect",
                { System: Systems, username: Username },
                { headers: { Authorization: `Bearer ${token}` } });
            const p = res.data && res.data.pending;
            if (p && p.id) {
                const dec = (p.amount_kip != null) ? (Number(p.amount_kip) / 100) : null;
                this.setState({
                    expStep: "reserved", expId: p.id,
                    expDecimal: dec, expBaht: Number(p.amount_baht) || null,
                    expMatched: false,
                });
                this.startExpTimers((p.secondsLeft != null) ? p.secondsLeft : ((p.expireMin || 30) * 60));
            }
        } catch (e) { /* ignore */ }
    };

    renderKbankReserve() {
        const { expStep, expInput, expLoading, expDecimal, expBaht, expSecLeft, expMatched, mainacc } = this.state;
        const chips = [100, 300, 500, 1000, 2000, 5000];
        const mm = String(Math.floor(expSecLeft / 60)).padStart(2, '0');
        const ss = String(expSecLeft % 60).padStart(2, '0');
        const box = { background: "rgba(0,0,0,0.25)", border: "1px solid rgba(251,191,36,0.3)", borderRadius: "14px", padding: "16px", marginBottom: "16px", color: "#fff" };
        if (expMatched) {
            return (
                <div style={{ ...box, border: "1px solid #00c853" }}>
                    <div style={{ fontWeight: 800, color: "#00e676", fontSize: 16, marginBottom: 6 }}>✓ เติมเงินสำเร็จ</div>
                    <div style={{ fontSize: 14, opacity: 0.9 }}>ระบบได้รับยอดและเติม {Number(expBaht || 0).toLocaleString()} บาท เข้าบัญชีแล้ว</div>
                </div>
            );
        }
        if (expStep === "reserved") {
            return (
                <div style={box}>
                    <div style={{ fontSize: 13, color: "#fbbf24", fontWeight: 700, marginBottom: 8 }}>⚠️ โอนยอดนี้ให้ตรงเป๊ะ (รวมทศนิยม)</div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                        <div style={{ fontSize: "2rem", fontWeight: 800, letterSpacing: "0.02em", fontFamily: "'Courier New',monospace" }}>
                            {Number(expDecimal || 0).toFixed(2)} <span style={{ fontSize: "1rem", fontWeight: 600 }}>บาท</span>
                        </div>
                        <button onClick={() => this.copyToClipboard(Number(expDecimal || 0).toFixed(2))}
                            style={{ background: "linear-gradient(135deg,#00c853,#009624)", border: "none", borderRadius: "10px", color: "#fff", padding: "10px 14px", fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
                            📋 คัดลอกยอด
                        </button>
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.85, marginTop: 8 }}>
                        จะได้รับเครดิต {Number(expBaht || 0).toLocaleString()} บาท • เหลือเวลา <span style={{ color: "#ff5252", fontWeight: 800 }}>{mm}:{ss}</span>
                    </div>
                    <div style={{ fontSize: 12.5, opacity: 0.8, marginTop: 6, lineHeight: 1.7 }}>
                        • โอนเข้าบัญชี {mainacc ? mainacc.fullname_th : ""} ด้านล่าง<br />
                        • ต้องโอนยอด <b>{Number(expDecimal || 0).toFixed(2)}</b> เท่านั้น ระบบจึงจะเติมอัตโนมัติ<br />
                        • กำลังรอตรวจสอบยอดเข้า...
                    </div>
                    <button onClick={this.cancelExpect}
                        style={{ marginTop: 12, width: "100%", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "10px", color: "#fff", padding: "10px", fontWeight: 600, cursor: "pointer" }}>
                        ยกเลิกรายการ
                    </button>
                </div>
            );
        }
        // input
        const canSubmit = Number(expInput) > 0 && !expLoading;
        return (
            <div style={box}>
                {this.state.expExpiredNote && (
                    <div style={{ background: "rgba(255,82,82,0.12)", border: "1px solid #ff5252", borderRadius: "10px", padding: "10px 12px", marginBottom: 12, color: "#ff8a80", fontSize: 12.5, lineHeight: 1.6 }}>
                        ⏱ รายการก่อนหน้าหมดเวลาแล้ว — ยอดที่โอนหลังหมดเวลาจะไม่เข้าอัตโนมัติ หากโอนไปแล้วกรุณาติดต่อแอดมิน แล้วเลือกยอดใหม่ด้านล่าง
                    </div>
                )}
                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 10 }}>เลือกยอดที่จะฝาก (กสิกร)</div>
                <input type="number" inputMode="numeric" value={expInput}
                    onChange={(e) => this.setState({ expInput: e.target.value })}
                    placeholder="ระบุจำนวนเงิน (บาท)"
                    style={{ width: "100%", padding: "12px 14px", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.2)", background: "rgba(255,255,255,0.06)", color: "#fff", fontSize: "1.1rem", marginBottom: 10, boxSizing: "border-box" }} />
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
                    {chips.map((c) => (
                        <button key={c} onClick={() => this.setState({ expInput: String(c) })}
                            style={{ flex: "1 0 28%", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.18)", borderRadius: "10px", color: "#fff", padding: "10px 0", fontWeight: 700, cursor: "pointer" }}>
                            {c.toLocaleString()}
                        </button>
                    ))}
                </div>
                <button onClick={this.createExpect} disabled={!canSubmit}
                    style={{ width: "100%", background: canSubmit ? "linear-gradient(135deg,#fbbf24,#f59e0b)" : "rgba(255,255,255,0.15)", border: "none", borderRadius: "12px", color: canSubmit ? "#1a1a1a" : "rgba(255,255,255,0.5)", padding: "13px", fontWeight: 800, fontSize: "0.95rem", cursor: canSubmit ? "pointer" : "not-allowed" }}>
                    {expLoading ? "กำลังสร้างรายการ..." : "สร้างรายการฝาก → รับยอดโอน"}
                </button>
                <div style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>
                    * ระบบจะสร้างยอดโอนแบบมีทศนิยมไม่ซ้ำ ให้โอนตรงยอดเพื่อเติมอัตโนมัติ
                </div>
            </div>
        );
    }

    get lang() {
        return localStorage.getItem('lang') || 'th';
    }

    componentWillUnmount() { this.stopExpTimers(); }

    async componentDidMount() {
        await this.loadConfig();
        this.maybeResumeExpect();
    }

    loadConfig = async () => {
        const token = localStorage.getItem("auth_token");
        if (!token) {
            this.setState({ loading: false });
            return;
        }
        try {
            // Auto-fill truemoney phone from registered playerid (phone number)
            let autoPhone = "";
            try {
                const decoded = jwt_decode(token);
                autoPhone = decoded?.message?.playerid || "";
            } catch (e) { /* ignore */ }

            // เรียกพร้อมกัน: getdepositconfig + getqrcode (fallback payment gateway)
            const [res, qrRes] = await Promise.all([
                instance.post(
                    "/api/v1/getdepositconfig",
                    { System: Systems, username: autoPhone },
                    { headers: { Authorization: `Bearer ${token}` } }
                ),
                instance.post(
                    "/api/v1/getqrcode",
                    { System: Systems, username: autoPhone, amount: 50 },
                    { headers: { Authorization: `Bearer ${token}` } }
                ).catch(() => ({ data: {} })),
            ]);

            if (res.data.status === 200) {
                const { config, mainacc, mainaccAutoslip, truewallet, cryptowallets } = res.data;
                let { paymentgateway } = res.data;

                // fallback: ถ้า getdepositconfig ไม่มี payment gateway ให้ใช้ getqrcode แทน
                const qrPayment = qrRes.data?.tblpaymentgatewayx || null;
                if (!paymentgateway && qrPayment) {
                    paymentgateway = qrPayment;
                    config.hasPaymentGateway = true;
                }

                // Pick the first available tab as default
                let activeTab = null;
                if (config.hasBank)              activeTab = "bank";
                else if (config.hasBankAutoslip) activeTab = "autoslip";
                else if (config.hasTruewallet)   activeTab = "true";
                else if (config.hasPaymentGateway) activeTab = "payment";
                else if (config.hasCrypto)       activeTab = "crypto";

                const { userbank } = res.data;
                this.setState({
                    loading: false,
                    config,
                    mainacc,
                    mainaccAutoslip,
                    truewallet,
                    paymentgateway,
                    cryptowallets: cryptowallets || [],
                    activeTab,
                    truemoneyPhone: autoPhone,
                    userbank: userbank || null,
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (e) {
            console.error("[deposit2] loadConfig error:", e);
            this.setState({ loading: false });
        }
    };

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copySuccess: true });
            setTimeout(() => this.setState({ copySuccess: false }), 2000);
        });
    };

    handleSlipChange = (e) => {
        this.setState({ slipFile: e.target.files[0] });
    };

    handleSlipUpload = async () => {
        const { slipFile } = this.state;
        if (!slipFile) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;

        this.setState({ slipUploading: true });
        try {
            const ext = (slipFile.name.match(/\.([a-z0-9]+)$/i)?.[1] || "jpg").toLowerCase();
            const filename = `slip_${Username}_${Date.now()}.${ext}`;
            const formData = new FormData();
            formData.append("file", slipFile, filename);
            formData.append("filename", filename);
            const headers = { "Content-Type": "multipart/form-data" };
            const resUpload = await instance.post(
                "https://r2-public.wordbalance931.workers.dev/upload/slip",
                formData,
                { headers }
            );
            const slip = resUpload?.data?.link || null;
            if (slip) {
                await instance.post("/api/v1/confirmdeposit", {
                    username: Username,
                    System: Systems,
                    slip,
                    type: 7,
                    autoslip: 1,
                }, { headers: { Authorization: `Bearer ${token}` } });
                this.setState({ slipSuccess: true, slipFile: null });
                setTimeout(() => this.setState({ slipSuccess: false }), 3000);
            }
        } catch (e) {
            console.error("[deposit2] slipUpload error:", e);
        }
        this.setState({ slipUploading: false });
    };

    handleTrueSubmit = async () => {
        const { truemoneyAmount, truemoneyPhone } = this.state;
        if (!truemoneyAmount || !truemoneyPhone) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        this.setState({ truemoneySubmitting: true });
        try {
            await instance.post("/api/v1/deposittruewallet", {
                username: Username,
                System: Systems,
                amount: truemoneyAmount,
                phone: truemoneyPhone,
            }, { headers: { Authorization: `Bearer ${token}` } });
            alert(t(this.lang, 'truemoney_submit_success'));
            this.setState({ truemoneyAmount: "", truemoneyPhone: "" });
        } catch (e) {
            console.error("[deposit2] trueSubmit error:", e);
        }
        this.setState({ truemoneySubmitting: false });
    };

    handleGiftSubmit = async () => {
        const { giftUrl } = this.state;
        if (!giftUrl || !giftUrl.includes("gift.truemoney.com")) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        this.setState({ giftSubmitting: true });
        try {
            await instance.post("/api/v1/depositgifttrue", {
                username: Username,
                System: Systems,
                linkurl: giftUrl,
            }, { headers: { Authorization: `Bearer ${token}` } });
            alert(t(this.lang, 'gift_submit_success'));
            this.setState({ giftUrl: "" });
        } catch (e) {
            console.error("[deposit2] giftSubmit error:", e);
        }
        this.setState({ giftSubmitting: false });
    };

    renderTabBar() {
        const { config, activeTab } = this.state;
        if (!config) return null;
        const lang = this.lang;

        const tabs = [];
        if (config.hasBank)
            tabs.push({ key: "bank",     label: t(lang, 'bank_tab'),         img: "https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/7c0dc589-eb20-4725-98df-0531730fff00/public" });
        if (config.hasBankAutoslip)
            tabs.push({ key: "autoslip", label: t(lang, 'upload_slip_tab'),  img: "https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/47a8d8e8-6424-4e84-41f7-f119c3b14e00/public" });
        if (config.hasTruewallet)
            tabs.push({ key: "true",     label: t(lang, 'truemoney_tab'),    img: "https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a152f75f-0588-49aa-2836-4d9528f69000/public" });
        if (config.hasPaymentGateway)
            tabs.push({ key: "payment",  label: "Payment",                   icon: "💳" });
        if (config.hasCrypto)
            tabs.push({ key: "crypto",   label: t(lang, 'crypto_tab'),       icon: "₿" });

        const activeStyle = {
            background: "linear-gradient(135deg, #b903fd 0%, #00d3e3 100%)",
            border: "none",
            borderRadius: "14px",
            padding: "10px 14px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "5px",
            cursor: "pointer",
            minWidth: "76px",
            flex: "1",
            maxWidth: "120px",
            color: "#fff",
            fontSize: "0.72rem",
            fontWeight: "700",
            boxShadow: "0 0 20px rgba(185,3,253,0.55), 0 0 10px rgba(0,211,227,0.35)",
            transition: "all 0.2s ease",
        };
        const inactiveStyle = {
            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(0,211,227,0.30)",
            borderRadius: "14px",
            padding: "10px 14px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "5px",
            cursor: "pointer",
            minWidth: "76px",
            flex: "1",
            maxWidth: "120px",
            color: "rgba(255,255,255,0.65)",
            fontSize: "0.72rem",
            fontWeight: "400",
            boxShadow: "none",
            transition: "all 0.2s ease",
        };

        return (
            <div style={{ padding: "10px 4px 14px" }}>
                <div style={{ display: "flex", gap: "8px", justifyContent: "center", flexWrap: "wrap" }}>
                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.key;
                        return (
                            <button
                                key={tab.key}
                                onClick={() => this.setState({ activeTab: tab.key })}
                                style={isActive ? activeStyle : inactiveStyle}
                            >
                                {tab.img
                                    ? <img src={tab.img} alt="" style={{ width: 34, height: 34, objectFit: "contain", filter: isActive ? "none" : "brightness(0.75)" }} />
                                    : <span style={{ fontSize: "1.6rem", lineHeight: 1 }}>{tab.icon}</span>
                                }
                                <span>{tab.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }


    handleBankQR = async () => {
        const { depositAmount } = this.state;
        if (!depositAmount || Number(depositAmount) <= 0) return;
        const token = localStorage.getItem("auth_token");
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        this.setState({ bankLoading: true, bankQR: null, bankLink: null });
        try {
            const res = await instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: depositAmount,
            }, { headers: { Authorization: `Bearer ${token}` } });
            const qr = res.data?.Jackpotlist?.depositQR;
            if (qr) {
                this.setState({ bankQR: qr.QRcode || null, bankLink: qr.link || null });
            }
        } catch (e) {
            console.error("[deposit2] bankQR error:", e);
        }
        this.setState({ bankLoading: false });
    };

    renderBankTab() {
        const { mainacc, copySuccess } = this.state;
        // User's own bank comes from main.js via props (checkpoint API)
        const accArr = this.props.accnumber;
        const userbank = Array.isArray(accArr) && accArr.length > 0 ? accArr[0] : null;
        // Name from JWT (most reliable — already decoded in loadConfig)
        let userFullName = null;
        try {
            const _tok = localStorage.getItem("auth_token");
            if (_tok) {
                const _dec = jwt_decode(_tok);
                const fn = _dec?.message?.firstname || "";
                const ln = _dec?.message?.lastname || "";
                userFullName = (fn && fn !== "undefined" && fn !== "null") ? fn : null;
            }
        } catch (e) { /* ignore */ }
        const lang = this.lang;
        if (!mainacc) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_bank_account')}</p>;

        const raw = mainacc.accnumber.replace(/\D/g, "");
        const accFmt = raw.length === 10
            ? `${raw.substring(0,3)}-${raw.substring(3,4)}-${raw.substring(4,9)}-${raw.substring(9,10)}`
            : raw;

        // Auto-pick card gradient from bank name
        const bName = (mainacc.fullname_th || "").toLowerCase();
        let cardGrad = "linear-gradient(135deg,#1a237e 0%,#283593 60%,#3949ab 100%)";
        if (bName.includes("กสิกร") || bName.includes("kbank"))   cardGrad = "linear-gradient(135deg,#1b5e20 0%,#2e7d32 60%,#43a047 100%)";
        else if (bName.includes("ไทยพาณิชย์") || bName.includes("scb")) cardGrad = "linear-gradient(135deg,#4a148c 0%,#6a1b9a 60%,#8e24aa 100%)";
        else if (bName.includes("กรุงเทพ") || bName.includes("bbl"))    cardGrad = "linear-gradient(135deg,#0d1b5e 0%,#1a237e 60%,#1565c0 100%)";
        else if (bName.includes("กรุงไทย") || bName.includes("ktb"))    cardGrad = "linear-gradient(135deg,#00695c 0%,#00796b 60%,#00acc1 100%)";
        else if (bName.includes("ทหารไทย") || bName.includes("ttb"))    cardGrad = "linear-gradient(135deg,#0d47a1 0%,#1565c0 60%,#1e88e5 100%)";
        else if (bName.includes("กรุงศรี") || bName.includes("bay"))    cardGrad = "linear-gradient(135deg,#bf360c 0%,#d84315 60%,#f4511e 100%)";

        return (
            <div className="p-3">
                {/* ── KBANK: จองยอดทศนิยมก่อนโอน (เฉพาะบัญชีรับฝากกสิกร) ── */}
                {this.isKbankAcc(mainacc) && this.renderKbankReserve()}
                {/* บัญชีปลายทาง: ธนาคารทั่วไปโชว์ปกติ; กสิกรโชว์เฉพาะหลังกด "สร้างรายการฝาก" แล้ว (expStep==='reserved') */}
                {(!this.isKbankAcc(mainacc) || this.state.expStep === "reserved") && (<>
                {/* ── Bank Card ── */}
                <div style={{
                    background: cardGrad,
                    borderRadius: "20px",
                    padding: "22px 20px",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 10px 36px rgba(0,0,0,0.45)",
                    marginBottom: "16px",
                }}>
                    {/* Decorative blobs */}
                    <div style={{ position:"absolute", top:-40, right:-40, width:130, height:130, borderRadius:"50%", background:"rgba(255,255,255,0.06)", pointerEvents:"none" }} />
                    <div style={{ position:"absolute", bottom:-30, left:-25, width:100, height:100, borderRadius:"50%", background:"rgba(255,255,255,0.05)", pointerEvents:"none" }} />

                    {/* Row 1: logo + bank name + badge */}
                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"18px" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                            <div style={{ width:46, height:46, borderRadius:"12px", background:"rgba(255,255,255,0.92)", display:"flex", alignItems:"center", justifyContent:"center", padding:"4px", flexShrink:0 }}>
                                <img src={mainacc.img_path} alt="bank" style={{ width:"100%", height:"100%", objectFit:"contain" }} />
                            </div>
                            <div>
                                <div style={{ color:"rgba(255,255,255,0.6)", fontSize:"0.65rem", letterSpacing:"0.06em", textTransform:"uppercase" }}>{t(lang, 'bank_dest')}</div>
                                <div style={{ color:"#fff", fontWeight:"bold", fontSize:"0.95rem", lineHeight:1.3 }}>{mainacc.fullname_th}</div>
                            </div>
                        </div>
                        <div style={{ background:"rgba(255,255,255,0.15)", backdropFilter:"blur(4px)", borderRadius:"20px", padding:"4px 12px", fontSize:"0.68rem", color:"rgba(255,255,255,0.85)", border:"1px solid rgba(255,255,255,0.2)", whiteSpace:"nowrap" }}>
                            {t(lang, 'savings_type')}
                        </div>
                    </div>

                    {/* Row 2: account number */}
                    <div style={{ marginBottom:"14px" }}>
                        <div style={{ color:"rgba(255,255,255,0.5)", fontSize:"0.66rem", marginBottom:"4px", letterSpacing:"0.08em" }}>{t(lang, 'acc_no_label')}</div>
                        <div style={{ color:"#fff", fontSize:"1.35rem", fontWeight:"bold", letterSpacing:"0.16em", fontFamily:"'Courier New',monospace" }}>
                            {accFmt}
                        </div>
                    </div>

                    {/* Row 3: account holder */}
                    <div>
                        <div style={{ color:"rgba(255,255,255,0.55)", fontSize:"0.65rem", marginBottom:"4px", letterSpacing:"0.06em" }}>เจ้าของบัญชี</div>
                        <div style={{ color:"#fff", fontSize:"1.05rem", fontWeight:"800", letterSpacing:"0.04em", textShadow:"0 1px 4px rgba(0,0,0,0.3)" }}>
                            {mainacc.first_name_en} {mainacc.last_name_en}
                        </div>
                    </div>
                </div>

                {/* ── Copy button ── */}
                <button
                    onClick={() => this.copyToClipboard(mainacc.accnumber)}
                    style={{
                        width:"100%",
                        background: copySuccess
                            ? "linear-gradient(135deg,#00c853,#009624)"
                            : "linear-gradient(135deg,rgba(255,255,255,0.1),rgba(255,255,255,0.05))",
                        border: copySuccess ? "1px solid #00c853" : "1px solid rgba(255,255,255,0.18)",
                        borderRadius:"12px",
                        color: copySuccess ? "#00e676" : "#fff",
                        padding:"13px",
                        fontSize:"0.9rem",
                        fontWeight:"bold",
                        cursor:"pointer",
                        transition:"all 0.3s ease",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        gap:"8px",
                        marginBottom:"14px",
                        letterSpacing:"0.03em",
                    }}
                >
                    <span style={{ fontSize:"1.1rem" }}>{copySuccess ? "✓" : "📋"}</span>
                    {copySuccess ? t(lang, 'copy_acc_done') : `${t(lang, 'copy_acc_prefix')}  ${accFmt}`}
                </button>

                {/* ── Conditions (เงื่อนไขการฝากเงิน) ── */}
                <div style={{
                    background:"rgba(0,0,0,0.22)",
                    border:"1px solid rgba(251,191,36,0.25)",
                    borderRadius:"12px",
                    padding:"12px 16px",
                    marginBottom:"14px",
                    fontSize:14,
                    color:"#fff",
                }}>
                    <div style={{ fontWeight:700, marginBottom:8, color:"#fbbf24", fontSize:15, display:"flex", alignItems:"center", gap:6 }}>
                        <span>⚠️</span> {t(lang, 'conditions_title')}
                    </div>
                    <ul style={{ margin:0, paddingLeft:18, lineHeight:2, opacity:0.9 }}>
                        <li style={{ fontSize:"0.8rem" }}>{t(lang, 'bank_transfer_warning')}</li>
                        <li style={{ fontSize:"0.8rem" }}>{t(lang, 'cond_pay_2')}</li>
                    </ul>
                </div>

                {/* ── User's own bank (transfer FROM) ── */}
                {userbank ? (
                    <div style={{
                        background:"rgba(0,211,227,0.08)",
                        border:"1px solid rgba(0,211,227,0.25)",
                        borderRadius:"12px",
                        padding:"12px 14px",
                        display:"flex", alignItems:"center", gap:"12px",
                        marginBottom:"14px",
                    }}>
                        {userbank.img_path && (
                            <div style={{ width:38, height:38, borderRadius:"10px", background:"rgba(255,255,255,0.9)", display:"flex", alignItems:"center", justifyContent:"center", padding:"3px", flexShrink:0 }}>
                                <img src={userbank.img_path} alt="mybank" style={{ width:"100%", height:"100%", objectFit:"contain" }} />
                            </div>
                        )}
                        <div style={{ flex:1, minWidth:0 }}>
                            <div style={{ fontSize:"0.62rem", color:"rgba(0,211,227,0.75)", marginBottom:"2px", letterSpacing:"0.06em" }}>
                                บัญชีของคุณ (โอนจาก)
                            </div>
                            <div style={{ color:"#fff", fontWeight:"bold", fontSize:"0.88rem" }}>
                                {userbank.fullname_th || userbank.acro || userbank.accbank}
                            </div>
                            {userFullName && (
                                <div style={{ color:"rgba(255,255,255,0.75)", fontSize:"0.8rem", marginTop:1 }}>
                                    {userFullName}
                                </div>
                            )}
                            <div style={{ color:"rgba(255,255,255,0.55)", fontSize:"0.78rem", fontFamily:"'Courier New',monospace", letterSpacing:"0.1em" }}>
                                {(() => { const r = (userbank.accno||"").replace(/\D/g,""); return r.length===10 ? `${r.substring(0,3)}-${r.substring(3,4)}-${r.substring(4,9)}-${r.substring(9,10)}` : r; })()}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{
                        background:"rgba(255,255,255,0.04)",
                        border:"1px dashed rgba(255,255,255,0.15)",
                        borderRadius:"12px",
                        padding:"12px 14px",
                        marginBottom:"14px",
                        textAlign:"center",
                        color:"rgba(255,255,255,0.35)",
                        fontSize:"0.78rem",
                    }}>
                        ไม่พบบัญชีที่ลงทะเบียน
                    </div>
                )}


                </>)}
            </div>
        );
    }

    renderAutoslipTab() {
        const { mainaccAutoslip, slipFile, slipUploading, slipSuccess, copySuccess } = this.state;
        const lang = this.lang;
        if (!mainaccAutoslip) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_autoslip')}</p>;
        const accFmt = `${mainaccAutoslip.accnumber.substring(0,3)}-${mainaccAutoslip.accnumber.substring(3,9)}-${mainaccAutoslip.accnumber.substring(9,12)}`;
        return (
            <div className="p-3">
                <div className="deposit-card">
                    <div className="deposit-bankline">
                        <img className="deposit-banklogo" src={mainaccAutoslip.img_path} alt="bank" />
                        <div className="deposit-bankname">{mainaccAutoslip.fullname_th}</div>
                    </div>
                    <div className="deposit-accline">
                        {mainaccAutoslip.first_name_en} {mainaccAutoslip.last_name_en} : {accFmt}
                    </div>
                    <div className="deposit-actions mt-2">
                        <button
                            className="deposit-btn deposit-btn--ghost w-100"
                            onClick={() => this.copyToClipboard(mainaccAutoslip.accnumber)}
                        >
                            {t(lang, 'acc_no_label')} : <b>{accFmt}</b>
                            &nbsp;<span className="deposit-chip">{copySuccess ? "✓ " + t(lang, 'copied') : t(lang, 'copy')}</span>
                        </button>
                    </div>
                </div>
                <div className="mt-3">
                    <label className="text-white-v1 d-block mb-1" style={{ fontSize: "0.85rem" }}>📎 {t(lang, 'upload_slip_auto_label')}</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={this.handleSlipChange}
                        disabled={slipUploading}
                        className="form-control mb-2"
                        style={{ background: "rgba(255,255,255,0.1)", color: "#fff" }}
                    />
                    {slipFile && (
                        <button
                            className="btn w-100 p-2"
                            style={{ background: "linear-gradient(135deg,#00c853,#009624)", color: "#fff", fontWeight: "bold", borderRadius: "8px" }}
                            onClick={this.handleSlipUpload}
                            disabled={slipUploading}
                        >
                            {slipUploading ? "⏳ " + t(lang, 'uploading') : "✅ " + t(lang, 'confirm_upload_slip')}
                        </button>
                    )}
                    {slipSuccess && (
                        <div className="alert mt-2 text-center" style={{ background: "rgba(0,200,83,0.2)", color: "#00c853", border: "1px solid #00c853", borderRadius: "8px" }}>
                            ✅ {t(lang, 'upload_success_checking')}
                        </div>
                    )}
                </div>
                <small className="text-center d-block mt-2" style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.78rem" }}>
                    ⚠️ {t(lang, 'transfer_warning_short')}
                </small>
            </div>
        );
    }

    renderTrueTab() {
        const { truewallet, truemoneyPhone } = this.state;
        const lang = this.lang;
        if (!truewallet) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_truewallet')}</p>;
        const merchantPhone = truewallet.telnumber || truewallet.acctelnumber || "";

        return (
            <div className="p-3">
                {/* ── TrueMoney hero card ── */}
                <div style={{
                    background: "linear-gradient(135deg,#ff6b00 0%,#ffb300 100%)",
                    borderRadius: "20px",
                    padding: "28px 20px",
                    textAlign: "center",
                    boxShadow: "0 10px 36px rgba(255,107,0,0.45)",
                    marginBottom: "16px",
                    position: "relative",
                    overflow: "hidden",
                }}>
                    <div style={{ position:"absolute", top:-40, right:-40, width:130, height:130, borderRadius:"50%", background:"rgba(255,255,255,0.08)", pointerEvents:"none" }} />
                    <div style={{ position:"absolute", bottom:-30, left:-25, width:100, height:100, borderRadius:"50%", background:"rgba(255,255,255,0.06)", pointerEvents:"none" }} />
                    <img
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a152f75f-0588-49aa-2836-4d9528f69000/public"
                        alt="TrueMoney"
                        style={{ width: 68, height: 68, borderRadius: 16, marginBottom: 12, objectFit:"contain", background:"rgba(255,255,255,0.15)", padding:6 }}
                        onError={(e) => { e.target.src = "https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a152f75f-0588-49aa-2836-4d9528f69000/public"; }}
                    />
                    <div style={{ color:"rgba(255,255,255,0.75)", fontSize:"0.68rem", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:4 }}>
                        TrueMoney Wallet
                    </div>
                    <div style={{ color:"#fff", fontSize:"1.6rem", fontWeight:"900", letterSpacing:"0.18em", fontFamily:"'Courier New',monospace" }}>
                        {merchantPhone}
                    </div>
                </div>

                {/* ── Copy button ── */}
                <button
                    onClick={() => {
                        navigator.clipboard.writeText(merchantPhone).then(() => {
                            this.setState({ copySuccess: true });
                            setTimeout(() => this.setState({ copySuccess: false }), 2000);
                        });
                    }}
                    style={{
                        width:"100%",
                        background:"rgba(255,179,0,0.15)",
                        border:"1px solid rgba(255,179,0,0.4)",
                        borderRadius:"12px",
                        color:"#ffb300",
                        padding:"12px",
                        fontSize:"0.9rem",
                        fontWeight:"bold",
                        cursor:"pointer",
                        marginBottom:"14px",
                        display:"flex", alignItems:"center", justifyContent:"center", gap:"8px",
                    }}
                >
                    <span>📋</span> คัดลอกเบอร์
                </button>

                {/* ── Auto-detect notice ── */}
                <div style={{
                    background:"rgba(0,200,83,0.1)",
                    border:"1px solid rgba(0,200,83,0.3)",
                    borderRadius:"14px",
                    padding:"16px 14px",
                    marginBottom:"14px",
                    display:"flex", gap:"12px", alignItems:"flex-start",
                }}>
                    <span style={{ fontSize:"1.4rem", flexShrink:0 }}>✅</span>
                    <div>
                        <div style={{ color:"#00e676", fontWeight:"bold", fontSize:"0.88rem", marginBottom:4 }}>
                            ระบบตรวจสอบอัตโนมัติ
                        </div>
                        <div style={{ color:"rgba(255,255,255,0.65)", fontSize:"0.75rem", lineHeight:1.6 }}>
                            โอนเงินผ่าน TrueMoney Wallet มายังเบอร์ด้านบน ระบบจะตรวจสอบและเติมเงินเข้าบัญชีคุณโดยอัตโนมัติ <strong style={{color:"#00e676"}}>ไม่ต้องแจ้งฝาก</strong>
                        </div>
                    </div>
                </div>

                {/* ── User's phone (transfer FROM) ── */}
                {truemoneyPhone && (
                    <div style={{
                        background:"rgba(0,211,227,0.07)",
                        border:"1px solid rgba(0,211,227,0.22)",
                        borderRadius:"12px",
                        padding:"10px 14px",
                        display:"flex", alignItems:"center", gap:"10px",
                    }}>
                        <span style={{ fontSize:"1.1rem" }}>📱</span>
                        <div>
                            <div style={{ fontSize:"0.62rem", color:"rgba(0,211,227,0.75)", marginBottom:2 }}>เบอร์โทรที่ใช้โอน (บัญชีของคุณ)</div>
                            <div style={{ color:"#fff", fontWeight:"bold", fontSize:"0.9rem", letterSpacing:"0.1em", fontFamily:"'Courier New',monospace" }}>{truemoneyPhone}</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderGiftTab() {
        const { giftUrl, giftSubmitting } = this.state;
        const lang = this.lang;
        return (
            <div className="p-3">
                <div className="text-center mb-3">
                    <div style={{ fontSize: "2.5rem" }}>🎁</div>
                    <div className="text-white-v1" style={{ fontWeight: 700 }}>{t(lang, 'deposit_gift_truemoney')}</div>
                    <small style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.78rem" }}>
                        {t(lang, 'gift_paste_hint')}
                    </small>
                </div>
                <label className="text-white-v1 d-block mb-1" style={{ fontSize: "0.85rem" }}>{t(lang, 'gift_link_label')}</label>
                <input
                    type="url"
                    className="form-control mb-3"
                    placeholder="https://gift.truemoney.com/campaign/?v=..."
                    value={giftUrl}
                    onChange={(e) => this.setState({ giftUrl: e.target.value })}
                    style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)" }}
                />
                <button
                    className="btn w-100 p-3"
                    style={{ background: "linear-gradient(135deg,#e91e63,#c2185b)", color: "#fff", fontWeight: "bold", borderRadius: "8px" }}
                    onClick={this.handleGiftSubmit}
                    disabled={giftSubmitting || !giftUrl.includes("gift.truemoney.com")}
                >
                    {giftSubmitting ? "⏳ " + t(lang, 'checking') : "🎁 " + t(lang, 'send_gift_link')}
                </button>
            </div>
        );
    }

    handlePaymentSubmit = async () => {
        const { paymentAmount } = this.state;
        if (!paymentAmount || Number(paymentAmount) <= 0) return;
        const token = localStorage.getItem("auth_token");
        if (!token) return;
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        this.setState({ paymentLoading: true, paymentQR: null, paymentLink: null });
        try {
            const res = await instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: paymentAmount,
                paymentstate: 1,
            }, { headers: { Authorization: `Bearer ${token}` } });
            const pg = res.data?.tblpaymentgatewayx;
            if (pg?.link) {
                // เปิดลิ้งตรงเลย
                const ua = navigator.userAgent;
                const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes("Mac") && "ontouchend" in document);
                if (isIOS) {
                    window.location.href = pg.link;
                } else {
                    window.open(pg.link, "_blank", "noopener,noreferrer");
                }
                this.setState({ paymentLink: pg.link, paymentStep: "result" });
            } else if (pg?.QRcode) {
                this.setState({ paymentQR: pg.QRcode, paymentStep: "result" });
            } else {
                this.setState({ paymentStep: "result" });
            }
        } catch (e) {
            console.error("[deposit2] payment submit error:", e);
        }
        this.setState({ paymentLoading: false });
    };

    renderPaymentTab() {
        const { paymentgateway, paymentAmount, paymentLoading, paymentQR, paymentLink, paymentStep } = this.state;
        const lang = this.lang;
        if (!paymentgateway) return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_payment_gateway')}</p>;

        const quickAmounts = [100, 300, 500, 1000, 2000, 5000];

        if (paymentStep === "result") {
            return (
                <div className="p-3 text-center">
                    {paymentQR ? (
                        <>
                            <p style={{ color: "rgba(255,255,255,0.85)", marginBottom: 12 }}>
                                สแกน QR Code เพื่อชำระเงิน
                            </p>
                            <img
                                src={paymentQR}
                                alt="QR Code"
                                style={{ maxWidth: 240, borderRadius: 12, background: "#fff", padding: 10 }}
                            />
                        </>
                    ) : paymentLink ? (
                        <>
                            <p style={{ color: "rgba(255,255,255,0.85)", marginBottom: 12 }}>
                                กำลังเปิดหน้าชำระเงิน...
                            </p>
                            <a
                                href={paymentLink}
                                className="btn w-100 p-3 mb-2"
                                style={{ background: "linear-gradient(135deg,#1976d2,#0d47a1)", color: "#fff", fontWeight: "bold", borderRadius: 8 }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                💳 กดที่นี่เพื่อชำระเงิน
                            </a>
                        </>
                    ) : (
                        <p style={{ color: "rgba(255,255,255,0.6)" }}>{t(lang, 'contact_admin')}</p>
                    )}
                    <button
                        className="btn mt-3"
                        style={{ background: "rgba(255,255,255,0.15)", color: "#fff", borderRadius: 8, width: "100%" }}
                        onClick={() => this.setState({ paymentStep: "input", paymentQR: null, paymentLink: null, paymentAmount: "" })}
                    >
                        ← กลับ
                    </button>
                </div>
            );
        }

        const limits = this.props.limit || { min: 100, max: 50000 };
        const amtNum = Number(paymentAmount);
        const isValid = amtNum >= limits.min && amtNum <= limits.max;

        return (
            <div className="p-2 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                {/* Header */}
                <div className="text-center pt-3 pb-2">
                    <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 56, height: 56, borderRadius: "50%", background: "rgba(255,255,255,0.15)", marginBottom: 8 }}>
                        <i className="fas fa-qrcode" style={{ fontSize: 26 }}></i>
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 16 }}>Payment Gateway</div>
                    <div style={{ fontSize: 12, opacity: 0.75 }}>ชำระเงินผ่านระบบ Payment</div>
                </div>

                {/* Min/Max */}
                <div style={{ display: "flex", justifyContent: "space-between", background: "rgba(255,255,255,0.1)", borderRadius: 8, padding: "8px 14px", marginBottom: 12, fontSize: 13 }}>
                    <span><i className="fas fa-arrow-down" style={{ color: "#4ade80", marginRight: 4 }}></i>ฝากขั้นต่ำ <b>{limits.min.toLocaleString()}</b></span>
                    <span><i className="fas fa-arrow-up" style={{ color: "#f87171", marginRight: 4 }}></i>ฝากสูงสุด <b>{limits.max.toLocaleString()}</b></span>
                </div>

                {/* Amount input */}
                <div className="px-1 pb-1">
                    <input
                        type="number"
                        className="form-control promptpay-border-radius"
                        placeholder={`ระบุยอดฝาก (${limits.min.toLocaleString()} - ${limits.max.toLocaleString()})`}
                        value={paymentAmount}
                        onChange={e => this.setState({ paymentAmount: e.target.value })}
                        style={{ textAlign: "center", fontSize: 18, fontWeight: 600 }}
                    />
                </div>

                {/* Quick amounts — 3×3 numpad grid */}
                <div className="mb-2 mt-2 px-1">
                    <div className="row m-0">
                        {[100, 300, 500, 1000, 3000, 5000, 10000, 30000, 50000].map(amt => (
                            <div key={amt} className="col-4 px-1 mb-2">
                                <div
                                    className="card-amount text-white-v1"
                                    onClick={() => this.setState({ paymentAmount: String(amt) })}
                                    style={{
                                        cursor: "pointer", borderRadius: 8,
                                        padding: "6px 2px", textAlign: "center",
                                        fontSize: 13, fontWeight: 600,
                                        border: paymentAmount === String(amt) ? "2px solid #fff" : "2px solid transparent",
                                    }}
                                >
                                    {amt.toLocaleString()}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Confirm button */}
                <div className="px-1 pb-2">
                    <button
                        className="btn -btn-deposit w-100"
                        disabled={paymentLoading || !isValid}
                        onClick={this.handlePaymentSubmit}
                        style={{ fontWeight: 700, fontSize: 15, padding: "10px", opacity: !isValid ? 0.5 : 1 }}
                    >
                        {paymentLoading
                            ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 6 }}></i>กำลังโหลด...</>
                            : <><i className="fas fa-check-circle" style={{ marginRight: 6 }}></i>ยืนยันฝากเงิน</>
                        }
                    </button>
                </div>

                {/* Rules */}
                <div style={{ background: "rgba(0,0,0,0.2)", borderRadius: 10, padding: "12px 16px", margin: "4px 0 8px", fontSize: 14 }}>
                    <div style={{ fontWeight: 700, marginBottom: 8, color: "#fbbf24", fontSize: 15 }}>
                        <i className="fas fa-exclamation-circle" style={{ marginRight: 6 }}></i>เงื่อนไขการฝากเงิน
                    </div>
                    <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2, opacity: 0.95 }}>
                        <li>ฝากขั้นต่ำ <b>{limits.min.toLocaleString()}</b> บาท สูงสุด <b>{limits.max.toLocaleString()}</b> บาท</li>
                        <li>กรุณาโอนด้วยบัญชีที่ลงทะเบียนไว้เท่านั้น</li>
                        <li>หากไม่ได้รับเครดิตภายใน 5 นาที ติดต่อแอดมิน</li>
                        <li>ระบบจะตรวจสอบยอดโอนอัตโนมัติ</li>
                    </ul>
                </div>
            </div>
        );
    }

    renderCryptoTab() {
        const { cryptowallets, activeCryptoIdx, cryptoCopied, cryptoThbAmount } = this.state;
        const lang = this.lang;
        if (!cryptowallets || cryptowallets.length === 0)
            return <p className="text-center text-white-v1 mt-3">{t(lang, 'no_crypto')}</p>;

        const wallet = cryptowallets[activeCryptoIdx] || cryptowallets[0];

        // Network tag colors
        const netColor = { TRC20: "#c62828", ERC20: "#1565c0", BEP20: "#e65100", BTC: "#f9a825" };
        const tagColor = netColor[wallet.network] || "#37474f";

        return (
            <div className="p-3">
                {/* Wallet selector pills */}
                {cryptowallets.length > 1 && (
                    <div className="d-flex flex-wrap justify-content-center mb-3" style={{ gap: "6px" }}>
                        {cryptowallets.map((w, i) => (
                            <button
                                key={w.no}
                                onClick={() => this.setState({ activeCryptoIdx: i, cryptoCopied: null })}
                                style={{
                                    background: i === activeCryptoIdx ? "linear-gradient(135deg,#f9a825,#e65100)" : "rgba(255,255,255,0.1)",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "5px 14px",
                                    fontSize: "0.8rem",
                                    cursor: "pointer",
                                    fontWeight: i === activeCryptoIdx ? "bold" : "normal",
                                }}
                            >
                                {w.currency} <span style={{ opacity: 0.8, fontSize: "0.72rem" }}>({w.network})</span>
                            </button>
                        ))}
                    </div>
                )}

                {/* Exchange rate converter */}
                {(() => {
                    const rate = parseFloat(wallet.rate) || 36;
                    const thb  = parseFloat(cryptoThbAmount) || 0;
                    const usdt = thb > 0 ? (Math.ceil((thb / rate) * 1000) / 1000).toFixed(3) : null;
                    return (
                        <div style={{ marginBottom: 14 }}>
                            {/* Rate badge */}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, background: "rgba(249,168,37,0.12)", border: "1px solid rgba(249,168,37,0.35)", borderRadius: 8, padding: "7px 14px", marginBottom: 10 }}>
                                <span style={{ fontSize: 16, color: "#f9a825" }}>₿</span>
                                <span style={{ fontSize: 13, color: "#f9a825", fontWeight: "bold" }}>1 {wallet.currency || "USDT"}</span>
                                <span style={{ fontSize: 12, color: "rgba(255,255,255,0.55)" }}>=</span>
                                <span style={{ fontSize: 13, color: "#fde68a", fontWeight: "bold" }}>
                                    {rate.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {t(lang, 'baht')}
                                </span>
                            </div>

                            {/* THB input */}
                            <div style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.65)", marginBottom: 6 }}>{t(lang, 'crypto_thb_label')}</div>
                            <div style={{ display: "flex", alignItems: "center", background: "rgba(0,0,0,0.25)", borderRadius: 8, border: "1px solid rgba(249,168,37,0.4)", overflow: "hidden", marginBottom: usdt ? 8 : 0 }}>
                                <span style={{ padding: "0 12px", fontSize: 14, color: "#fde68a", fontWeight: "bold", borderRight: "1px solid rgba(249,168,37,0.3)" }}>฿</span>
                                <input
                                    type="number"
                                    min="0"
                                    placeholder="0.00"
                                    value={cryptoThbAmount || ""}
                                    onChange={(e) => this.setState({ cryptoThbAmount: e.target.value })}
                                    style={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#fff", fontSize: 15, fontWeight: "bold", padding: "10px 12px" }}
                                />
                                <span style={{ padding: "0 10px", fontSize: 12, color: "rgba(255,255,255,0.45)" }}>THB</span>
                            </div>

                            {/* Converted result */}
                            {usdt && (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "rgba(0,0,0,0.25)", border: "1px solid rgba(74,222,128,0.35)", borderRadius: 8, padding: "10px 14px" }}>
                                    <div>
                                        <div style={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.5)", marginBottom: 2 }}>{t(lang, 'crypto_amount_prefix')} {wallet.currency || "USDT"} {t(lang, 'crypto_amount_suffix')}</div>
                                        <div style={{ fontSize: 20, fontWeight: "bold", color: "#4ade80" }}>{usdt}</div>
                                        <div style={{ fontSize: "0.68rem", color: "rgba(255,255,255,0.4)" }}>{wallet.currency} · {wallet.network}</div>
                                    </div>
                                    <button
                                        onClick={() => { navigator.clipboard.writeText(usdt); this.setState({ cryptoCopied: "usdt" }); setTimeout(() => this.setState({ cryptoCopied: null }), 2000); }}
                                        style={{ background: "rgba(74,222,128,0.15)", border: "1px solid rgba(74,222,128,0.4)", borderRadius: 7, padding: "6px 12px", color: "#4ade80", fontSize: "0.75rem", cursor: "pointer", flexShrink: 0 }}
                                    >
                                        {cryptoCopied === "usdt" ? "✓ " + t(lang, 'copied') : "📋 " + t(lang, 'copy')}
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                })()}

                {/* Wallet card */}
                <div style={{
                    background: "linear-gradient(135deg,rgba(249,168,37,0.15),rgba(230,81,0,0.15))",
                    border: "1px solid rgba(249,168,37,0.4)",
                    borderRadius: "12px",
                    padding: "16px",
                }}>
                    {/* Currency + Network */}
                    <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                        <span style={{ fontSize: "1.6rem" }}>₿</span>
                        <div>
                            <div style={{ color: "#f9a825", fontWeight: "bold", fontSize: "1rem" }}>{wallet.currency}</div>
                            <span style={{
                                background: tagColor,
                                color: "#fff",
                                borderRadius: "10px",
                                padding: "1px 8px",
                                fontSize: "0.7rem",
                                fontWeight: "bold",
                            }}>{wallet.network}</span>
                        </div>
                        <div className="ms-auto text-end" style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.55)" }}>
                            {t(lang, 'min_label_short')} {parseFloat(wallet.min_amount).toFixed(2)} {wallet.currency}
                        </div>
                    </div>

                    {/* QR Code */}
                    {wallet.qrcode_img && (
                        <div className="text-center mb-3">
                            <img
                                src={wallet.qrcode_img}
                                alt="QR"
                                style={{ width: "150px", height: "150px", borderRadius: "8px", background: "#fff", padding: "4px" }}
                            />
                        </div>
                    )}

                    {/* Wallet address */}
                    <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.6)", marginBottom: "6px" }}>{t(lang, 'wallet_address_label')}</div>
                    <button
                        className="w-100"
                        onClick={() => {
                            navigator.clipboard.writeText(wallet.wallet_address);
                            this.setState({ cryptoCopied: "address" });
                            setTimeout(() => this.setState({ cryptoCopied: null }), 2500);
                        }}
                        style={{
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(249,168,37,0.35)",
                            borderRadius: "8px",
                            color: "#fff",
                            padding: "10px 12px",
                            fontSize: "0.78rem",
                            wordBreak: "break-all",
                            textAlign: "left",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        <span style={{ flex: 1 }}>{wallet.wallet_address}</span>
                        <span style={{
                            background: cryptoCopied === "address" ? "rgba(0,200,83,0.3)" : "rgba(249,168,37,0.25)",
                            color: cryptoCopied === "address" ? "#00c853" : "#f9a825",
                            borderRadius: "6px",
                            padding: "3px 8px",
                            fontSize: "0.7rem",
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                        }}>
                            {cryptoCopied === "address" ? "✓ " + t(lang, 'copied') : "📋 " + t(lang, 'copy')}
                        </span>
                    </button>
                </div>

                <small className="d-block text-center mt-3" style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.73rem" }}>
                    ⚠️ {t(lang, 'crypto_send_only')} {wallet.currency} {t(lang, 'crypto_network')} {wallet.network} {t(lang, 'crypto_send_only_suffix')}<br />
                    {t(lang, 'crypto_wrong_type_warning')}
                </small>
            </div>
        );
    }

    renderActiveTab() {
        const { activeTab } = this.state;
        switch (activeTab) {
            case "bank":     return this.renderBankTab();
            case "autoslip": return this.renderAutoslipTab();
            case "true":     return this.renderTrueTab();
            case "gift":     return this.renderGiftTab();
            case "payment":  return this.renderPaymentTab();
            case "crypto":   return this.renderCryptoTab();
            default:         return null;
        }
    }

    render() {
        const { loading, config } = this.state;
        const lang = this.lang;

        return (
            <div className="padding-router-view">
                <div className="container p-0 x-margin-top-v3">
                    <div className="row m-0 border-shadow-title">
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            {/* Header */}
                            <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                <div className="text-title text-white-v1 text-center">
                                    <div className="d-flex justify-content-between p-2">
                                        <div className="text-white-v1-deposit">
                                            <a role="button" onClick={() => this.props.onBack && this.props.onBack()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 1 1 1 .708.708L5.707 7.5z" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div className="text-white-v1-deposit"><h5>{t(lang, 'deposit_title')}</h5></div>
                                        <div>{/**/}</div>
                                    </div>
                                    <hr className="mt-0" />
                                </div>
                            </div>

                            <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                {loading ? (
                                    <div className="text-center text-white-v1 py-5">
                                        <div className="spinner-border text-light" role="status" />
                                        <div className="mt-2">{t(lang, 'loading')}</div>
                                    </div>
                                ) : !config ? (
                                    <div className="text-center text-white-v1 py-5">
                                        {t(lang, 'load_failed_retry')}
                                    </div>
                                ) : (
                                    <>
                                        {/* Tab Bar */}
                                        <div className="pt-2 px-2">
                                            {this.renderTabBar()}
                                        </div>
                                        {/* Active Tab Content */}
                                        <div className="mt-1">
                                            {this.renderActiveTab()}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Deposit2;
